export default "__VITE_ASSET__CZE$ZiKH__"